import { render, staticRenderFns } from "./CondicionIvaCombobox.vue?vue&type=template&id=16ba3b3d&scoped=true"
import script from "./CondicionIvaCombobox.vue?vue&type=script&lang=js"
export * from "./CondicionIvaCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ba3b3d",
  null
  
)

export default component.exports